import { useCalendar } from "Components/Common/hooks/useCalendar";
import { useCompany } from "Components/Company/hooks/useCompany";
import { CollectionPath, db } from "Configs/firebase";
import { createCollectionStore } from "Store/helpers/createCollectionStore";
import { ScheduleEntry, isScheduleEntry } from "domain-entities";
import { collection } from "firebase/firestore";
import { useEffect, useState } from "react";

export const useScheduleEntries = createCollectionStore<ScheduleEntry>({
	is: isScheduleEntry,
	sort: (a: ScheduleEntry, b: ScheduleEntry) => a.startTime - b.startTime,
});

export const useSubscribeToScheduleEntries = () => {
	const startOfWeek = useCalendar((state) => state.startOfWeek.unix());
	const [earliestStart, setEarliestStart] = useState(startOfWeek);
	const companyId = useCompany((state) => state.item?.id);

	if (startOfWeek < earliestStart) {
		setEarliestStart(startOfWeek);
	}

	useEffect(() => {
		if (!companyId) return;

		const ref = collection(
			db,
			CollectionPath.SCHEDULES,
			companyId,
			CollectionPath.SCHEDULE_ENTRIES
		);

		return useScheduleEntries
			.getState()
			.subscribe(ref, [["endTime", ">", earliestStart]]);
	}, [companyId, earliestStart]);

	useEffect(() => {
		return useScheduleEntries.getState().reset;
	}, []);
};
